function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496.933 496.933",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46f3e"
    },
    d: "M435.2 238.933c-25.446 0-47.607-13.952-59.349-34.603a86 86 0 0 1-8.917.469c-47.13 0-85.333-38.204-85.333-85.333 0-13.312 3.14-25.865 8.576-37.094C270.276 75.349 256 56.431 256 34.133c0-12.681 4.634-24.26 12.262-33.195C261.402.367 254.481 0 247.467 0 110.797 0 0 110.797 0 247.467s110.797 247.467 247.467 247.467 247.467-110.797 247.467-247.467c0-13.193-1.058-26.129-3.046-38.767-12.255 18.235-33.068 30.233-56.688 30.233",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#a46f3e",
      strokeWidth: 2
    },
    d: "M435.2 238.933c-25.446 0-47.607-13.952-59.349-34.603a86 86 0 0 1-8.917.469c-47.13 0-85.333-38.204-85.333-85.333 0-13.312 3.14-25.865 8.576-37.094C270.276 75.349 256 56.431 256 34.133c0-12.681 4.634-24.26 12.262-33.195C261.402.367 254.481 0 247.467 0 110.797 0 0 110.797 0 247.467s110.797 247.467 247.467 247.467 247.467-110.797 247.467-247.467c0-13.193-1.058-26.129-3.046-38.767-12.255 18.235-33.068 30.233-56.688 30.233z",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a3311"
    },
    d: "M179.2 179.2c0-23.561-19.106-42.667-42.667-42.667S93.867 155.639 93.867 179.2s19.106 42.667 42.667 42.667S179.2 202.761 179.2 179.2",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6a3311",
      strokeWidth: 2
    },
    d: "M179.2 179.2c0-23.561-19.106-42.667-42.667-42.667S93.867 155.639 93.867 179.2s19.106 42.667 42.667 42.667S179.2 202.761 179.2 179.2z",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a3311"
    },
    d: "M179.2 358.4c0-18.85-15.283-34.133-34.133-34.133s-34.133 15.283-34.133 34.133 15.283 34.133 34.133 34.133S179.2 377.25 179.2 358.4",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6a3311",
      strokeWidth: 2
    },
    d: "M179.2 358.4c0-18.85-15.283-34.133-34.133-34.133s-34.133 15.283-34.133 34.133 15.283 34.133 34.133 34.133S179.2 377.25 179.2 358.4z",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a3311"
    },
    d: "M375.467 358.4c0-32.99-26.743-59.733-59.733-59.733S256 325.41 256 358.4s26.743 59.733 59.733 59.733 59.734-26.743 59.734-59.733",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6a3311",
      strokeWidth: 2
    },
    d: "M375.467 358.4c0-32.99-26.743-59.733-59.733-59.733S256 325.41 256 358.4s26.743 59.733 59.733 59.733 59.734-26.743 59.734-59.733z",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a3311"
    },
    d: "M283.803 100.388a86 86 0 0 1 6.374-18.014c-19.9-7.023-34.176-25.941-34.176-48.239 0-2.893.307-5.7.768-8.457-.265-.009-.503-.077-.768-.077-23.569 0-42.667 19.098-42.667 42.667 0 23.561 19.098 42.667 42.667 42.667 10.676 0 20.319-4.062 27.802-10.547",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6a3311",
      strokeWidth: 2
    },
    d: "M283.803 100.388a86 86 0 0 1 6.374-18.014c-19.9-7.023-34.176-25.941-34.176-48.239 0-2.893.307-5.7.768-8.457-.265-.009-.503-.077-.768-.077-23.569 0-42.667 19.098-42.667 42.667 0 23.561 19.098 42.667 42.667 42.667 10.676 0 20.319-4.062 27.802-10.547z",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 7.50000095
    },
    d: "M175 201.933c0-11.287 5.85-23.1 15-30 0 6.338 5.175 15 15 15 12.427 0 22.5 10.073 22.5 22.5 0 2.895-.6 5.64-1.59 8.175 5.55 4.455 11.07 8.925 16.425 13.575l-15.585 15.6c-4.65-5.37-9.105-10.905-13.553-16.44-2.55.99-5.295 1.59-8.197 1.59-16.575 0-30-13.425-30-30m91.14 51.36 10.05-10.05c4.553 2.28 9.623 3.69 15.06 3.69 18.638 0 33.75-15.112 33.75-33.75 0-5.437-1.41-10.5-3.697-15.052L295 224.433l-15-15 26.303-26.302c-4.553-2.288-9.615-3.698-15.053-3.698-18.637 0-33.75 15.113-33.75 33.75 0 5.438 1.41 10.5 3.698 15.053L182.5 306.933l15 15 51.36-51.36c14.138 14.46 29.055 28.148 44.828 40.875l10.687 8.61 11.25-11.25L307 298.121c-12.712-15.773-26.4-30.69-40.86-44.828"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomize);
export default __webpack_public_path__ + "static/media/customize.b3bbcc039d2723c59afc183f87609921.svg";
export { ForwardRef as ReactComponent };